import { gql } from '@apollo/client';

export const ADD_NEW_STAFFS = gql`
  mutation addNewStaff($staffsDetails: [NewStaffInput]) {
    addNewStaff(staffsDetails: $staffsDetails)
  }
`;
